import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import default_user_img from "../../assets/default_user.svg";
import default_corporate_img from "../../assets/defaultCorporatePic.svg";
import edit from "../../assets/Edit.svg";
import "../../design-system.css";
import Modal from "../Modal/Modal";
import "./RoundedProfilePicture.css";
import {
  ArrowIcon,
  BackArrowIcon,
  CameraIcon,
  FolderIcon
} from "../../assets/assets";

function RoundedProfilePicture(props) {
  const [isUnableToDownloadImage, setIsUnableToDownloadImage] = useState(false);
  const profileInputElementRef = useRef(null);
  const [showCamera, setShowCamera] = useState(false);
  const [showUploadFrom, setShowUploadFrom] = useState(false);
  const [imageUploadType, setImageUploadType] = useState(false);
  function fileHandler(event) {
    if (event.target.files[0]) {
      props.setFile(URL.createObjectURL(event.target.files[0]));
    }
  }

  useEffect(() => {
    if (imageUploadType === "takePhoto") {
      setShowCamera(true);
    } else if (imageUploadType === "uploadFile") {
      profileInputElementRef?.current?.click();
    }
  }, [imageUploadType]);

  const getImageSize = () => {
    switch (props.size) {
      case "smaller":
        return `${
          props.removeResponsive ? "" : "adaptive-height_and_width_24px"
        } height_and_width_24px border-radius-100-percentage border-2px-grey background-white `;

      case "small":
        return `${
          props.removeResponsive
            ? ""
            : "adaptive-rounded-profile-picture-small-height-width"
        } rounded-profile-picture-small-height-width border-radius-100-percentage border-2px-grey background-white`;

      case "medium":
        return `${
          props.removeResponsive ? "" : "adaptive-height_and_width_44px"
        } height_and_width_44px border-radius-100-percentage border-2px-grey background-white`;

      case "header":
        return `${
          props.removeResponsive ? "" : "adaptive-height_and_width_44px"
        } height_and_width_44px border-radius-100-percentage border-2px-white header-profile-icon-box-shadow background-white `;

      case "large":
        return `${
          props.removeResponsive ? "" : "adaptive-height_and_width_84px"
        } height_and_width_84px border-radius-100-percentage border-2px-grey background-white`;

      default:
        return `${
          props.removeResponsive ? "" : "adaptive-height_and_width_24px"
        } height_and_width_24px`;
    }
  };

  const getShimmerSize = () => {
    switch (props.size) {
      case "smaller":
        return `shimmer ${
          props.removeResponsive ? "" : "adaptive-height_and_width_24px"
        } height_and_width_24px border-radius-100-percentage border-2px-grey`;

      case "small":
        return `shimmer ${
          props.removeResponsive
            ? ""
            : "adaptive-rounded-profile-picture-small-height-width"
        } rounded-profile-picture-small-height-width border-radius-100-percentage border-2px-grey`;

      case "medium":
        return `shimmer ${
          props.removeResponsive ? "" : "adaptive-height_and_width_44px"
        } height_and_width_44px border-radius-100-percentage border-2px-grey`;

      case "large":
        return `shimmer ${
          props.removeResponsive ? "" : "adaptive-height_and_width_84px"
        } height_and_width_84px border-radius-100-percentage border-2px-grey`;

      case "header":
        return `${
          props.removeResponsive ? "" : "adaptive-height_and_width_44px"
        } height_and_width_44px border-radius-100-percentage border-2px-white header-profile-icon-box-shadow background-white `;

      default:
        return `shimmer ${
          props.removeResponsive ? "" : "adaptive-height_and_width_24px"
        } height_and_width_24px`;
    }
  };

  const getFontSize = () => {
    switch (props.size) {
      case "smaller":
        return `${
          props.removeResponsive
            ? ""
            : "adaptive-rounded-profile-picture-display-letter-font-size-smaller"
        } rounded-profile-picture-display-letter-font-size-smaller`;

      case "small":
        return `${
          props.removeResponsive
            ? ""
            : "adaptive-rounded-profile-picture-display-letter-font-size-small"
        } rounded-profile-picture-display-letter-font-size-small`;

      case "medium":
        return `${
          props.removeResponsive
            ? ""
            : "adaptive-rounded-profile-picture-display-letter-font-size-medium"
        } rounded-profile-picture-display-letter-font-size-medium`;

      case "header":
        return `${
          props.removeResponsive
            ? ""
            : "adaptive-rounded-profile-picture-display-letter-font-size-medium"
        } rounded-profile-picture-display-letter-font-size-medium`;

      default:
        return `${
          props.removeResponsive
            ? ""
            : "adaptive-rounded-profile-picture-display-letter-font-size"
        } rounded-profile-picture-display-letter-font-size`;
    }
  };

  const getEditIconSize = () => {
    switch (props.size) {
      case "smaller":
        return `${
          props.removeResponsive ? "" : "adaptive-height_and_width_24px"
        } height_and_width_24px border-radius-100-percentage border-2px-grey background-white `;

      case "small":
        return `${
          props.removeResponsive
            ? ""
            : "adaptive-rounded-profile-picture-small-height-width"
        } rounded-profile-picture-small-height-width border-radius-100-percentage border-2px-grey background-white`;

      case "medium":
        return `${
          props.removeResponsive ? "" : "adaptive-height_and_width_44px"
        } height_and_width_44px border-radius-100-percentage border-2px-grey background-white `;

      case "large":
        return `${
          props.removeResponsive ? "" : "adaptive-height_and_width_84px"
        } height_and_width_84px border-radius-100-percentage border-2px-grey background-white`;

      case "header":
        return `${
          props.removeResponsive ? "" : "adaptive-height_and_width_44px"
        } height_and_width_44px border-radius-100-percentage border-2px-grey background-white `;

      default:
        return `${
          props.removeResponsive ? "" : "adaptive-height_and_width_24px"
        } height_and_width_24px`;
    }
  };

  return (
    <div className={`${getEditIconSize()} border-none position-relative`}>
      {props.loading === true ? (
        <div
          className={`${
            props.className ? props.className : ""
          } ${getShimmerSize()}`}
          data-cy={"profile-image-loader"}
        />
      ) : (
        <div className="position-relative ">
          {typeof props.src === "string" &&
          isUnableToDownloadImage === false ? (
            <div className="inherit-parent-height flex-place-children-page-center">
              <img
                onClick={props.onClick}
                data-cy={props["data-cy"] || "PROFILE-IMAGE"}
                src={props.src}
                className={` ${
                  props.className ? props.className : ``
                } cursor-pointer ${getImageSize()}`}
                alt={props.alt ? props.alt : ""}
                onError={(_) => {
                  setIsUnableToDownloadImage(true);
                }}
              />
            </div>
          ) : props.src === null &&
            typeof props.displayName === "string" &&
            props.displayName.trim().length > 0 &&
            typeof props.background === "string" &&
            props.background.trim().length > 0 ? (
            <div
              data-cy={props["data-cy"] || "PROFILE-IMAGE"}
              className={`${getImageSize()} text-align-center flex-center-children-horizontally flex-align-items-center font-family-gilroy-regular `}
              style={{ backgroundColor: `${props.background}` }}
              onClick={props.onClick}
            >
              <span
                className={`inherit-parent-height font-color-white text-transform-uppercase ${getFontSize()}`}
              >
                {props.displayName.trim().split("")[0]}
              </span>
            </div>
          ) : (
            <img
              onClick={props.onClick}
              data-cy={props["data-cy"] || "PROFILE-IMAGE"}
              src={
                props.userType === "corporate"
                  ? default_corporate_img
                  : default_user_img
              }
              className={`${
                props.className ? props.className : ``
              } cursor-pointer ${getImageSize()}`}
              alt={props.alt || ""}
              onError={(_) => {
                setIsUnableToDownloadImage(true);
              }}
            />
          )}

          {props.editMode === true && (
            <span
              className={`${
                props.removeResponsive
                  ? ""
                  : "adaptive-edit-profile-picture-icon-position"
              } edit-profile-picture-icon-position ${
                props.removeResponsive
                  ? ""
                  : "adaptive-edit-profile-picture-icon-size"
              } edit-profile-picture-icon-size flex-place-children-page-center box-shadow-default border-radius-100-percentage font-color-secondary background-white position-absolute text-align-center font-size-smaller`}
              onClick={() => {
                if (props.uploadFromAll) {
                  setShowUploadFrom(true);
                } else {
                  profileInputElementRef?.current?.click();
                }
              }}
            >
              <img src={edit} alt="edit-icon" width="100%" height="100%" />
            </span>
          )}
          {props.editMode === true &&
            props.mode === "camera" &&
            !props.uploadFromAll && (
              <span
                style={{
                  opacity: 0,
                  top: 0,
                  left: 0
                }}
                className={`position-absolute ${getEditIconSize()}`}
                onClick={() => setShowCamera(true)}
              />
            )}

          {props.editMode === true &&
            ((props.uploadFromAll && imageUploadType === "uploadFile") ||
              (!props.uploadFromAll && props.mode !== "camera")) && (
              <input
                ref={profileInputElementRef}
                type="file"
                accept="image/*"
                name="editImage"
                id="profilePic"
                style={{ top: "0" }}
                className={`position-absolute left-0 overflow-hidden opacity-zero ${getEditIconSize()}`}
                onClick={(event) => {
                  event.target.value = "";
                }}
                onChange={fileHandler}
              />
            )}
        </div>
      )}
      {props.loading !== true &&
        (props.size === "medium" || props.showNotificationCount === true) &&
        typeof props.notificationCount === "number" &&
        props.notificationCount !== 0 && (
          <div
            data-cy={
              props["notification-count-data-cy"]
                ? props["notification-count-data-cy"]
                : "HEADER-NOTIFICATION-COUNT"
            }
            className={`height-and-width-14px box-shadow-default flex-place-children-page-center border-radius-50-percentage font-color-secondary background-white position-absolute bottom-0-point-4-em position-left-0 text-align-center font-size-smaller ${
              props.notificationCount > 9
                ? "height-and-width-for-double-digit-number"
                : props.notificationCount > 99
                ? "height-and-width-for-triple-digit-number"
                : "height-and-width-for-single-digit-number"
            }`}
          >
            {props.notificationCount > 99 ? "99+" : props.notificationCount}
          </div>
        )}

      <Modal
        show={showCamera}
        canIgnore={true}
        onClose={() => {
          setShowCamera(!showCamera);
        }}
        background="background-transparent"
        width="inherit-parent-width"
        boxShadow="box-shadow-none"
        height="inherit-parent-height"
      >
        <CameraCapture
          onCapture={(image) => {
            props.setFile(image);
            setShowCamera(false);
          }}
          onClose={() => setShowCamera(false)}
        />
      </Modal>

      <Modal
        show={showUploadFrom}
        canIgnore={true}
        onClose={() => {
          setShowUploadFrom(!showUploadFrom);
        }}
        background="background-transparent"
        position="position-fixed bottom-0 left-0 right-0"
        width="inherit-parent-width"
        boxShadow="box-shadow-none"
        height="height-fit-to-content"
      >
        <div
          className=" inherit-parent-width padding-large font-color-secondary"
          style={{ background: "white" }}
        >
          <div className=" font-size-small text-align-center padding-vertical-default ">
            {" "}
            EDIT PROFILE IMAGE{" "}
          </div>

          {[
            {
              value: "Take Photo",
              id: "takePhoto",
              description: "Use camera to capture",
              icon: <CameraIcon />
            },
            {
              value: "Upload from file",
              id: "uploadFile",
              description: "Select image from device",
              icon: <FolderIcon />
            }
          ].map((data, i) => (
            <div
              key={i}
              className=" display-flex flex-justify-content-space-between flex-align-items-center padding-vertical-medium"
            >
              <div
                className=" display-flex flex"
                onClick={() => {
                  setImageUploadType(data.id);
                  setShowUploadFrom(!showUploadFrom);
                }}
              >
                {data.icon}
                <div className=" padding-left-default">
                  <div className=" font-size-large">{data.value}</div>
                  <div className=" font-size-small padding-top-small ">
                    {data.description}
                  </div>
                </div>
              </div>

              <ArrowIcon />
            </div>
          ))}
        </div>
      </Modal>
    </div>
  );
}

function CameraCapture({ onCapture, onClose }) {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  const [stream, setStream] = useState(null);
  const [facingMode, setFacingMode] = useState("environment");

  useEffect(() => {
    startCamera();

    return () => {
      stopCamera();
    };
    // eslint-disable-next-line
  }, [facingMode]);

  const startCamera = async () => {
    try {
      const mediaStream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode }
      });

      videoRef.current.srcObject = mediaStream;
      setStream(mediaStream);
    } catch (error) {
      console.error("Camera error:", error);
    }
  };

  const stopCamera = () => {
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
    }
  };

  const captureImage = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    const imageData = canvas.toDataURL("image/png");

    onCapture?.(imageData);

    stopCamera();
  };

  const rotateCamera = () => {
    setFacingMode((prev) => (prev === "environment" ? "user" : "environment"));
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "black",
        zIndex: 9999,
        display: "flex",
        flexDirection: "column"
      }}
    >
      <div className="padding-larger display-flex">
        <div onClick={onClose} className="padding-right-large">
          {" "}
          <BackArrowIcon color="white" />
        </div>
        <div className="font-color-white">Capture Image</div>
      </div>
      <video
        ref={videoRef}
        autoPlay
        playsInline
        style={{
          flex: 1,
          width: "100%",
          objectFit: "cover",
          transform: facingMode === "user" ? "scaleX(-1)" : "none"
        }}
      />

      <canvas ref={canvasRef} style={{ display: "none" }} />

      <div
        style={{
          position: "absolute",
          bottom: 0,
          width: "100%",
          padding: 24,
          background: "rgba(0,0,0,0.6)",
          display: "flex",
          alignItems: "center"
        }}
      >
        <div style={{ flex: 1 }} />

        <button
          className="ripple-element"
          style={{
            borderRadius: "100%",
            width: 70,
            height: 70,
            border: "solid 8px grey"
          }}
          onClick={captureImage}
        />

        <div style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
          <div onClick={rotateCamera}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
              <path d="M3 3v5h5" />
              <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" />
              <path d="M16 16h5v5" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}

RoundedProfilePicture.propTypes = {
  /**
   * source of the profile picture image.if src is `undefined` or `null` it shows default profile image
   */
  src: PropTypes.node,
  /**
   * shows loading suspense animation for the profile picture
   */
  loading: PropTypes.bool,
  /**
   * size of the profile picture component
   * sizes are `smaller` `small` `medium` `large`
   */
  size: PropTypes.oneOf(["smaller", "small", "medium", "large"]),
  /**
   * class name for parent element of the component
   */
  className: PropTypes.string,
  /**
   * onClick event of the profile image
   */
  onClick: PropTypes.func,
  /**
   * profile image selector attribute for cypress testing
   * default value is `data-cy="PROFILE-IMAGE"` loading state `data-cy="profile-image-loader"`
   */
  "data-cy": PropTypes.string,
  /**
   * alt attribute for the profile image. default value is "profile-picture"
   */
  alt: PropTypes.string,
  /**
   * which show profile picture edit image
   */
  editMode: PropTypes.bool,
  /**
   * used to show the notification count in profile picture
   * shows only if the value is `greater than 0` and the default value is 0. if the notification  count is greater than 99 then it shows `99+`
   */
  notificationCount: PropTypes.number,
  /**
   * to show notification count
   */
  showNotificationCount: PropTypes.bool
};

RoundedProfilePicture.defaultProps = {
  src: null,
  loading: false,
  size: "medium",
  className: "",
  onClick: undefined,
  "data-cy": "PROFILE-IMAGE",
  alt: "user-pic",
  editMode: false,
  notificationCount: 0,
  showNotificationCount: false
};
export default RoundedProfilePicture;
